import Switch from '../Switch';


function JsonBooleanEditor({path, node, setObject}) {
  return <Switch value={!!node} onChange={({target: {value}}) => setObject(path, !!value)} />;
}


export default JsonBooleanEditor;